import { defineMessages } from 'react-intl';

export const MESSAGES = defineMessages({
    name: {
        defaultMessage: 'Name',
        id: 'iaso.label.name',
    },
    algorithm: {
        defaultMessage: 'Algorithm',
        id: 'iaso.label.algorithm',
    },
    sourceorigin: {
        id: 'iaso.label.sourceorigin',
        defaultMessage: 'Origin source',
    },
    sourceoriginversion: {
        id: 'iaso.label.sourceoriginversion',
        defaultMessage: 'Origin source version',
    },
    sourcedestination: {
        id: 'iaso.label.sourcedestination',
        defaultMessage: 'Destination source',
    },
    sourcedestinationversion: {
        id: 'iaso.label.sourcedestinationversion',
        defaultMessage: 'Destination source version',
    },
    launcher: {
        defaultMessage: 'Launcher',
        id: 'iaso.label.launcher',
    },
    endedAt: {
        defaultMessage: 'Stopped at',
        id: 'iaso.label.ended_at',
    },
    launchedAt: {
        defaultMessage: 'Launched at',
        id: 'iaso.label.launched_at',
    },
    origin: {
        defaultMessage: 'Origin',
        id: 'iaso.label.origin',
    },
    source: {
        defaultMessage: 'Source',
        id: 'iaso.label.source',
    },
    version: {
        defaultMessage: 'Version',
        id: 'iaso.label.version',
    },
    destination: {
        defaultMessage: 'Destination',
        id: 'iaso.label.destination',
    },
    deleteRunTitle: {
        id: 'iaso.runs.dialog.deleteRunTitle',
        defaultMessage: 'Are you sure you want to delete this run?',
    },
    deleteRunText: {
        id: 'iaso.runs.dialog.deleteRunText',
        defaultMessage: 'All created links will be deleted.',
    },
    addRun: {
        id: 'iaso.algo.addRun',
        defaultMessage: 'Add algorithm run',
    },
    links: {
        defaultMessage: 'Links',
        id: 'iaso.label.links',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    save: {
        id: 'iaso.label.save',
        defaultMessage: 'Save',
    },
    requiredField: {
        id: 'iaso.forms.error.fieldRequired',
        defaultMessage: 'This field is required',
    },
});
